import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener } from '@angular/core';

@Component({
  selector: 'lib-n-popover',
  templateUrl: './n-popover.component.html',
  styleUrls: ['./n-popover.component.scss'],
  standalone: true,
  imports: [CommonModule],
  animations: [
    // Animação para o backdrop
    trigger('backdropFade', [
      state('void', style({ opacity: 0 })),
      state('*', style({ opacity: 1 })),
      transition('* <=> void', animate('300ms ease-in-out')),
    ]),
    // Animação para o painel (conteúdo)
    trigger('panelSlide', [
      // Para mobile (slide de baixo para cima)
      transition('void => mobile', [
        style({ transform: 'translateY(100%)' }),
        animate('300ms ease-out', style({ transform: 'translateY(0%)' })),
      ]),
      transition('mobile => void', [
        animate('300ms ease-in', style({ transform: 'translateY(100%)' })),
      ]),
      // Para desktop (fade e leve slide)
      transition('void => desktop', [
        style({ opacity: 0, transform: 'translateY(-20px)' }),
        animate(
          '300ms ease-out',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
      transition('desktop => void', [
        animate(
          '300ms ease-in',
          style({ opacity: 0, transform: 'translateY(-20px)' })
        ),
      ]),
    ]),
  ],
})
export class NPopoverComponent {
  isOpen = false;
  isDesktop = window.innerWidth >= 768; // Define o breakpoint

  constructor(private elementRef: ElementRef) {}

  // Fecha o popover ao pressionar a tecla 'Escape'
  @HostListener('document:keydown.escape')
  onEscapeKey() {
    this.close();
  }

  // Atualiza a flag isDesktop se a janela for redimensionada
  @HostListener('window:resize')
  onResize() {
    this.isDesktop = window.innerWidth >= 768;
  }

  public open(): void {
    if (this.isOpen) return;
    this.isOpen = true;
    this.lockBodyScroll();
  }

  public close(): void {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.unlockBodyScroll();
  }

  public toggle(): void {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  // Impede que o scroll da página funcione com o popover aberto
  private lockBodyScroll(): void {
    document.body.style.overflow = 'hidden';
  }

  // Libera o scroll
  private unlockBodyScroll(): void {
    document.body.style.overflow = 'auto';
  }
}
